<div class="forgot-container">
  <div class="logo-container">
    <img src="assets/img/logo-projecao-profissional.svg" alt="Logo Projeção Profissional" class="forgot-logo" />
  </div>
  <h1 class="forgot-title">Recuperar Senha</h1>
  <p class="forgot-subtitle">Digite seu e-mail e enviaremos as instruções para redefinir sua senha.</p>
  
  <form [formGroup]="forgotForm" (ngSubmit)="forgotPassword()" (keydown.enter)="forgotPassword()">
    <mat-form-field appearance="outline" class="email-field">
      <mat-label>E-mail</mat-label>
      <input
        matInput
        type="email"
        formControlName="email"
        name="email"
        required
        autocomplete="email"
        [disabled]="isLoading"
      />
      <mat-error *ngIf="forgotForm.get('email')?.hasError('required') && forgotForm.get('email')?.touched">
        E-mail é obrigatório
      </mat-error>
      <mat-error *ngIf="forgotForm.get('email')?.hasError('email') && forgotForm.get('email')?.touched">
        Digite um e-mail válido
      </mat-error>
    </mat-form-field>

    <button 
      mat-raised-button 
      color="primary" 
      type="submit" 
      [disabled]="forgotForm.invalid || isLoading"
      class="forgot-submit-button"
    >
      <mat-spinner *ngIf="isLoading" diameter="20" class="button-spinner"></mat-spinner>
      <span *ngIf="!isLoading">Enviar Instruções</span>
      <span *ngIf="isLoading">Enviando...</span>
    </button>
  </form>

  <div *ngIf="message" class="message">{{ message }}</div>
  <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
  <a routerLink="/sign-in" class="back-to-login">Voltar para Login</a>
</div>
